export enum LanguageProficiency {
  Proficient = 'Proficient',
  Fluent = 'Fluent',
  Basic = 'Basic',
}
